import React from 'react';

import {
    ColorSelect,
    ColorSelectProps,
} from 'reactComponents/Tags/ColorSelect/ColorSelect';

import { BasicField, BasicFieldProps } from './_BasicField';

export type FieldColorProps = Omit<
    BasicFieldProps & ColorSelectProps,
    'control' | 'value'
>;

export const FieldColor = ({ label = 'Цвет', ...props }: FieldColorProps) => (
    // @ts-ignore
    <BasicField {...{ ...props, label }} control={ColorSelect} />
);
